import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebaseConfig";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";

const TagPage = () => {
  const { tag } = useParams();
  const [news, setNews] = useState([]);
  const [visibleCount, setVisibleCount] = useState(10);
  
  useEffect(() => {
	   setVisibleCount(10);
    const q = query(
      collection(db, "news"),
      where("tags", "array-contains", decodeURIComponent(tag)),
      orderBy("timestamp", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setNews(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    });

    return () => unsubscribe();
  }, [tag]);

return (
  <div style={{ maxWidth: "1100px", margin: "30px auto", padding: "0 10px" }}>
<div
  style={{
    marginBottom: "25px",
    paddingBottom: "12px",
    borderBottom: "1px solid #ddd",
  }}
>
  <h2
    style={{
      margin: 0,
      display: "flex",
      alignItems: "center",
      gap: "12px",
      fontSize: "30px",
      color: "#333",
      borderLeft: "5px solid #d2202a",
      paddingLeft: "12px",
      lineHeight: 1.1,
    }}
  >
    <span>কী-ওয়ার্ড: {decodeURIComponent(tag)}</span>

    <span
      style={{
        fontSize: "15px",
        color: "#777",
        fontWeight: "normal",
      }}
    >
      ({news.length}টি সংবাদ)
    </span>
  </h2>
</div>
	
<div
  style={{
    display: "grid",
    gridTemplateColumns:
      window.innerWidth <= 768 ? "1fr" : "1fr 1fr",
    gap: "12px 20px",
  }}
>
   {news.slice(0, visibleCount).map((item) => (
      <Link
        key={item.id}
        to={`/${item.categorySlug || "general"}/${item.subcategorySlug || "general"}/${item.id}`}
        style={{
          display: "flex",
         gap: window.innerWidth <= 768 ? "10px" : "15px",
          textDecoration: "none",
          color: "#333",
          borderBottom: "1px solid #eee",
          padding: "15px 0",
		  background: "#fff",
          transition: "0.25s ease",
        }}
		onMouseEnter={(e) => {
  e.currentTarget.style.background = "#f8f8f8";

  const title = e.currentTarget.querySelector("h3");
  if (title) title.style.color = "#4169E1";
}}

onMouseLeave={(e) => {
  e.currentTarget.style.background = "#fff";

  const title = e.currentTarget.querySelector("h3");
  if (title) title.style.color = "#333";
}}
      >
        <img
          src={item.image}
          alt=""
          style={{
            width: window.innerWidth <= 768 ? "110px" : "170px",
height: window.innerWidth <= 768 ? "75px" : "100px",
borderRadius: "4px",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />

        <div>
      <h3
  style={{
    margin: "0 0 8px 0",
   fontSize: window.innerWidth <= 768 ? "17px" : "20px",
    fontWeight: "bold",
    color: "#000000",
    lineHeight: "1.2",
    transition: "0.2s",
  }}
>
            {item.title}
          </h3>

         <p
  style={{
    margin: 0,
    fontSize: window.innerWidth <= 768 ? "13px" : "16px",
    color: "#555",
    lineHeight: "1.4",
    textAlign: "justify",
  }}
>
  {item.content?.length > (window.innerWidth <= 768 ? 65 : 130)
    ? item.content.substring(
        0,
        window.innerWidth <= 768 ? 65 : 130
      ) + "..."
    : item.content}
</p>
		  
        </div>
      </Link>
    ))}
	</div>
	
	{news.length > visibleCount && (
  <div style={{ textAlign: "center", marginTop: "30px" }}>
    <button
      onClick={() => setVisibleCount((prev) => prev + 10)}
      style={{
        padding: "10px 24px",
        background: "#4169E1",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        fontSize: "16px",
      }}
    >
      আরও পড়ুন
    </button>
  </div>
)}
  </div>
);
};
export default TagPage;